<template>
  <div class="waitlist-insert mb-4 pb-2 w-100">
    <b-row
      id="no-listing-results"
      :class="['mx-auto blue-5--bg blue-10--border br-8', isMobile ? 'p-4' : 'p-3']"
    >
      <b-col cols="12" xl="9">
        <h2 :class="isMobile ? 'header-md mb-1' : 'header-sm mb-1'">
          New listings coming soon in {{ market.displayName }}
        </h2>
        <p :class="isMobile ? 'font-base' : 'font-large'">
          Get notified when new properties hit the market
        </p>
        <b-button variant="gradient" class="mb-1" v-limit="275" block @click="onCTAClick">
          Join the list
        </b-button>
      </b-col>
      <b-col xl="3" class="d-none d-xl-flex align-items-center">
        <img
          height="130"
          src="https://assets.bungalow.com/illustrations/full-color/happy-home.png"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ListingsWaitlistInsert',
  props: {
    market: {
      type: Object,
      required: true,
    },
    onCTAClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
}
</script>
